import copy from 'copy-to-clipboard'
import React, { useState } from 'react'
import Icon from '../Icon'
import PopoutButton from './PopoutButton'
import { useTranslation } from '../../../lib/i18n'

const CopyButton = ({ copyable, label, copiedLabel, isPopout = true }) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const finalLabel = label || t('common.copyLink')
  const finalCopiedLabel = copiedLabel || t('common.copied')

  function copyToClipboard(text) {
    copy(text)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 5000)
  }

  if (isPopout) {
    return (
      <PopoutButton onClick={() => copyToClipboard(copyable)}>
        {copied ? finalCopiedLabel : finalLabel}
      </PopoutButton>
    )
  }

  return (
    <div className="flex flex-col">
      <span className="font-bold mb-2">{finalLabel}</span>
      <button
        className="bg-alt-bg rounded-md placeholder-subtitle border-0 focus:outline-none focus:ring-1 focus:ring-subtitle flex flex-row cursor-pointer h-full px-4 py-3 "
        onClick={() => copyToClipboard(copyable)}
      >
        <b className="overflow-hidden w-full text-left text-gray-700">
          {copyable}
        </b>

        <Icon name="link" size={22} className="m-auto" />
      </button>
      <span className="ml-4 mt-2 text-subtitle italic">
        {copied ? t('common.copiedToClipboard') : t('common.clickToCopy')}
      </span>
    </div>
  )
}

export default CopyButton
